import { z } from "zod";
import { VisualMediaSchema } from "../Media";
export function generateContentGroupSchema(schema) {
    return z.object({
        label: z.string().optional(),
        thumbnail: VisualMediaSchema.optional(),
        color: z.string().optional(),
        content: schema.optional(),
    });
}
//# sourceMappingURL=helpers.js.map